import {
  ID__ATS_TYPE__NONE
} from '../../Definition';
import {
  getShortURL
} from '../../GenericTools.lib';
import {
  MODEL_NAME_EMPLOYER
} from '../../models/employer';
import {
  Obj
} from '../../Object.lib';
import {
  DIC__ATS__MODELS
} from './AtsModels.dic';
import getAtsContextMapped from './getAtsContextMapped.fun';

export default function getAtsContextSingle({
  entity = {},
  entityName = MODEL_NAME_EMPLOYER,
  atsTypeId = ID__ATS_TYPE__NONE
}) {
  const CONTEXT__ATS = {
    ...Obj(Obj(DIC__ATS__MODELS[entityName])[atsTypeId]),
    ...Obj(getAtsContextMapped({ entity, atsTypeId })[atsTypeId])
  };
  return {
    apiName: (
      CONTEXT__ATS.apiName ||
      getShortURL(
        CONTEXT__ATS.manualSubmissionUrl
      )
    ),
    ...CONTEXT__ATS,
  };
}
